import { Dropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchStores } from 'utils/api/storeApi'

type Props = {
  setValue: any
  error?: string
  label: string
  name: string
  defaultValue?: string
  storeId?: any
  required?: boolean
}

const StoreSelect = ({
  setValue,
  error,
  label,
  name,
  defaultValue,
  storeId,
  required = false,
}: Props) => {
  const [options, setOptions] = useState<any>([
    {
      label: '--NONE--',
      value: '',
      disabled: false,
    },
  ])
  const [loading, setLoading] = useState<boolean>(true)

  const getStores = async () => {
    try {
      const { data } = await fetchStores({
        limit: 600,
        page: 1,
        isActive: true,
        // third-party stores are handled by a separate flow
        isThirdPartyStore: false,
      })
      let stores = data?.docs?.map((store: any) => ({
        label: store.storeName,
        value: store._id,
        disabled: false,
      }))

      if (!stores || stores.length <= 0) {
        return setOptions([])
      }
      if (storeId) {
        stores = stores.filter((store: any) => store?.value !== storeId)
      }
      setOptions([...options, ...stores])
    } catch (error) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <Dropdown
      defaultValue={defaultValue}
      label={label}
      setValue={setValue}
      options={options}
      name={name}
      error={error}
      required={required}
    />
  )
}

export default memo(StoreSelect)
